var winWidth = $(window).width();

$(".leadership--item--link").on("click", function (e) {
  e.preventDefault();

  $(".leadership--item").removeClass("is-expanded");
  $(".leadership--item--link").attr("aria-expanded", "false");
  $(".leadership--bio").attr("aria-hidden", "true");

  $(this).parent().toggleClass("is-expanded");

  if ($(this).parent().hasClass("is-expanded")) {
    $(this).attr("aria-expanded", "true");
    var href = $(this).attr("href");
    $(href).attr("aria-hidden", "false");
  } else {
    $(this).attr("aria-expanded", "false");
  }

  var itemHeight = $(this).height();
  var gridOffset = $(this).offset();
  var banner = winWidth > 1199 ? 0 : 80;

  $("html, body").animate(
    {
      scrollTop: gridOffset.top + itemHeight,
    },
    750
  );
});

$(".leadership--bio--close").on("click", function (e) {
  e.preventDefault();

  var bio = $(this).closest(".leadership--bio");
  bio.prev().removeClass("is-expanded");

  var leadershipItem = bio.prev().find(".leadership--item--link");
  leadershipItem.attr("aria-expanded", "false");

  bio.attr("aria-hidden", "true");

  var leadershipItemOffset = bio.prev().offset();
  var banner = winWidth > 1199 ? 102 : 80;

  $("html, body").animate(
    {
      scrollTop: leadershipItemOffset.top - banner,
    },
    750
  );
});
